Constellations = function(scene) {
	/*---------------------------------------------------
		STATIC VARIABLES
	--------------------------------------------------*/
	this.SPHERE_WIDTH = 500;
	this.POINTS = 300;
	this.minDistance = 60;
	this.pointTravelDistance = 10;

	/*---------------------------------------------------
		VARIABLES
	--------------------------------------------------*/
	this.scene = scene;
	this.init();
};

Constellations.prototype = {

	constructor: Constellations,

	/*---------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/
	
	init : function(){
		this.createPointMesh();
		this.createLineMesh();
	},
	
	createPointMesh : function(){
		var sphere = new THREE.SphereGeometry( this.SPHERE_WIDTH , 32, 32, 0, 2 * Math.PI, 2 * Math.PI, 1.3 );
	
		var randPoints = THREE.GeometryUtils.randomPointsInGeometry( sphere, this.POINTS  );
		


		this.positions = new Float32Array( this.POINTS * 3 );
		this.positionsS  = new Float32Array( this.POINTS * 3 );
		this.speed = new Float32Array( this.POINTS * 3 );

		for ( var i = 0, l = this.POINTS; i < l; i ++ ) {
			this.speed[(i * 3)]  =  (-Math.random() * 2 + Math.random() * 2) / 10;
			this.speed[(i * 3)+1] = (-Math.random() * 2 + Math.random() * 2) / 10;
			this.speed[(i * 3)+2] = (-Math.random() * 2 + Math.random() * 2) / 10;
			this.positions[(i * 3)] = randPoints[ i ].x ;
			this.positions[(i * 3)+1] =  randPoints[ i ].y;
			this.positions[(i * 3)+2] = randPoints[ i ].z;
			this.positionsS[(i * 3)] = randPoints[ i ].x ;
			this.positionsS[(i * 3)+1] =  randPoints[ i ].y;
			this.positionsS[(i * 3)+2] = randPoints[ i ].z;
		}

		var geometry = new THREE.BufferGeometry();
		geometry.addAttribute( 'speed', new THREE.BufferAttribute( this.speed, 3 ) );
		geometry.addAttribute( 'position', new THREE.BufferAttribute( this.positions, 3 ) );
		geometry.addAttribute( 'positionS', new THREE.BufferAttribute( this.positionsS, 3 ) );
		var pMaterial = new THREE.PointsMaterial( {
					color : 0xffffff,
					size : 3,
					blending : THREE.AdditiveBlending,
					transparent : true,
					sizeAttenuation : false,
					opacity : 0.2
		} );
		
		this.particles = new THREE.Points( geometry, pMaterial );
		this.scene.add( this.particles );
	},
	
	createLineMesh : function(){
		this.positionsL = new Float32Array( 12000 );

		this.geometry = new THREE.BufferGeometry();
		this.geometry.addAttribute( 'position', new THREE.BufferAttribute( this.positionsL, 3 ).setDynamic( true ) );
		this.geometry.computeBoundingSphere();
		this.geometry.setDrawRange( 0, 0 );
		var material = new THREE.LineBasicMaterial( {
			color : 0xffffff,
			blending : THREE.AdditiveBlending,
			transparent : true,
			opacity : 0.2,
			depthTest : true,
			depthWrite : false,
			linewidth : 3
		} );

		this.linesMesh = new THREE.LineSegments( this.geometry, material );
		this.linesMesh.frustumCulled = false;
		this.scene.add( this.linesMesh  );
	},

	getTexture : function( id ){

		var texture = new THREE.Texture( app.loader.getItem( id ) );
		texture.needsUpdate = true;
		return texture;

	},

	render : function() {

		this.vertexpos = 0;
		this.numConnected = 0;

		for ( var i = 0; i < this.POINTS; i++ ) {
			this.pointPos = i * 3;
			this.positions[ this.pointPos ] += this.speed[ this.pointPos ];
			this.positions[ this.pointPos + 1 ] += this.speed[ this.pointPos + 1 ];
			this.positions[ this.pointPos + 2 ] += this.speed[ this.pointPos + 2 ];

			//CHECK POINT TRAVEL LIMITS
			if ( this.positions[ this.pointPos  ] < this.positionsS[ this.pointPos  ] - this.pointTravelDistance || this.positions[ this.pointPos  ] > this.positionsS[ this.pointPos ] + this.pointTravelDistance )
				this.speed[ this.pointPos     ] = -this.speed[ this.pointPos ];
			
			if ( this.positions[ this.pointPos + 1 ] < this.positionsS[ this.pointPos + 1 ] - this.pointTravelDistance || this.positions[ this.pointPos + 1 ] > this.positionsS[ this.pointPos + 1 ] + this.pointTravelDistance )
				this.speed[ this.pointPos +1 ] = -this.speed[ this.pointPos + 1 ];

			if ( this.positions[ this.pointPos + 2 ] < this.positionsS[ this.pointPos + 2 ] - this.pointTravelDistance || this.positions[ this.pointPos + 2 ] > this.positionsS[ this.pointPos + 2 ] + this.pointTravelDistance )
				this.speed[ this.pointPos + 2 ] = -this.speed[ i * 3 + 2 ];
			
			/////////////////////////////////////////////////////
			// Check Collision
			////////////////////////////////////////////////////

			for ( var j = i + 1; j < this.POINTS; j++ ) {
				this.pointPosEnd = j * 3;
				var dx = this.positions[ this.pointPos ] - this.positions[ this.pointPosEnd ];
				var dy = this.positions[ this.pointPos + 1 ] - this.positions[ this.pointPosEnd + 1 ];
				var dz = this.positions[ this.pointPos + 2 ] - this.positions[ this.pointPosEnd + 2 ];
				var distP = Math.sqrt( dx * dx + dy *dy + dz * dz );
				if ( distP < this.minDistance ) {
					this.positionsL[ this.vertexpos++ ] = this.positions[ this.pointPos ];
					this.positionsL[ this.vertexpos++ ] = this.positions[ this.pointPos + 1 ];
					this.positionsL[ this.vertexpos++ ] = this.positions[ this.pointPos + 2 ];
					this.positionsL[ this.vertexpos++ ] = this.positions[ this.pointPosEnd ];
					this.positionsL[ this.vertexpos++ ] = this.positions[ this.pointPosEnd + 1 ];
					this.positionsL[ this.vertexpos++ ] = this.positions[ this.pointPosEnd + 2 ];
					this.numConnected ++;
				}
			}

		}

		this.particles.geometry.attributes.speed.needsUpdate = true;
		this.particles.geometry.attributes.position.needsUpdate = true;
		this.linesMesh.geometry.setDrawRange( 0, this.numConnected * 2 );
		this.linesMesh.geometry.attributes.position.needsUpdate = true;
	}

};
